/**
 * ITP-E-179-03 (story 23) — the malware scan chip of a ticket attachment (ITP-E-179-01, ADR 0171), as the ticket's attachment
 * list shows it. TaskAttachmentsQuery carries the attachment's ScanStatus: Pending or Error read Scanning… (the download is
 * refused until the scan says Clean), Infected is blocked. Clean, NotScanned (scanning off on the cluster) and no status at all
 * (a file from before scanning, preflight D8) are downloadable and show no chip.
 */
export type TicketAttachmentChip = 'scanning' | 'ready' | 'blocked';

/** The scan status of an attachment row from TaskAttachmentsQuery, in either key casing. */
export function ticketAttachmentScanStatus(attachment: any): string | null {
  return attachment?.ScanStatus ?? attachment?.scanStatus ?? null;
}

export function ticketAttachmentChip(attachment: any): TicketAttachmentChip {
  switch (ticketAttachmentScanStatus(attachment)) {
    case 'Pending':
    case 'Error':
      return 'scanning';
    case 'Infected':
      return 'blocked';
    default:
      return 'ready';
  }
}

export function ticketAttachmentChipLabel(chip: TicketAttachmentChip): string {
  switch (chip) {
    case 'scanning':
      return 'Scanning…';
    case 'blocked':
      return 'Blocked: threat found';
    default:
      return '';
  }
}

/** Some attachment is still being scanned: the list re-reads until it is not. */
export function anyTicketAttachmentScanning(attachments: any[] | null | undefined): boolean {
  return (attachments ?? []).some(a => ticketAttachmentChip(a) === 'scanning');
}
